export enum WorkspaceTabKindType {
  Resource = 'resource',
  Route = 'route',
}
